import { createSlice } from "@reduxjs/toolkit";

const initialState ={
    modalShow : false,
    modalModifShow : false,
    list :[],
    listCat :[],
    listMarque :[],
    ajoutOk : false,
    modifOk : false,
    current :[],
}
const Produits = createSlice({
    name : 'ProduitsData',
    initialState,
    reducers :{
        showmodal:(state,action) =>{
            state.modalShow=action.payload
        },
        getList:(state,action) =>{
            state.list=action.payload
        },
        getListMarque:(state,action) =>{
            state.listMarque=action.payload
        },
        getListCat:(state,action) =>{
            state.listCat=action.payload
        },
        current:(state,action) =>{
            state.current=action.payload
        },
        ajout:(state,action) =>{
            state.ajoutOk=action.payload
    },
        modif:(state,action) =>{
        state.modifOk=action.payload
},
        addOne:(state,action) =>{
            state.list.push(action.payload)
    },
        modalModifShow:(state,action) =>{
            state.modalModifShow=action.payload
},
    update: (state, action) => {

        const element = state.list.find(element => element._id === action.payload.idproduit);
        if (element) {
            element.designation = action.payload.designation;
            element.marque = action.payload.marque;
            element.categorie = action.payload.categorie;
            element.prix_vente = action.payload.prix_vente;
            element.prix_achat = action.payload.prix_achat;
            element.qte_pack = action.payload.qte_pack;
            element.tva = action.payload.tva;

    }
  },
  remove: (state, action) => {    
    const id = action.payload;
    state.list=state.list.filter(element => element._id !== id);
  }

    }
})

export const {showmodal,getList,ajout,modif,addOne,modalModifShow,update,current,remove,getListMarque,getListCat} = Produits.actions
export default Produits.reducer;